"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./MobileBenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/engagement.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "STRENGTHEN CUSTOMER ENGAGEMENT",
      description: "Mobile apps help you create a direct marketing channel between your businesses and your customers, allowing for direct and effective communication.",
    },
    {
      iconSrc: "/loyalty.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "INCREASE CUSTOMER LOYALTY",
      title: "A PRODUCT READY TO LAUNCH",
      description: "Apps send notifications about what's new or what has changed in your services or products. This will help your business build a strong relationship with your customers and develop a genuine customer base and stronger loyalty.",
    },
    {
      iconSrc: "/edge.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "HAVE A COMPETITIVE EDGE",
      description: "Communication speed is vital for customer satisfaction. As we move towards a mobile-centric culture, having a mobile app and even a web app will help propel your business into the hands of existing and new clients and ensure future business success.",
    },
    {
      iconSrc: "/brand.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "BUILD A STRONG BRAND",
      description:
        "One of the most important things a mobile app offers to consumers is awareness of and communication with your brand. You’ll build trust with your target market by interacting with them regularly.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header">
          <h2 className="scoping-benefits-title489 animate-left" ref={headerRef}>
           Creating a seamless<br></br>
            User experience
            
            <span className="scoping-benefits-highlight"> IN ANY DEVICE</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
            Maximize profits with our mobile app development services, adjusted to your market needs and user experience.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
